import React, { useEffect, useRef } from 'react';
import L from 'leaflet';
import 'leaflet/dist/leaflet.css';
import { statsService } from '../services/api';
import styles from './ProtestMap.module.css';

const SYRIA_CENTER = [34.8021, 38.9968];

const GOVERNORATE_COORDS = {
    'دمشق':       [33.5138, 36.2765],
    'ريف دمشق':   [33.6667, 36.5],
    'حلب':        [36.2021, 37.1343],
    'حماة':       [34.7303, 36.7539],
    'حمص':        [34.7324, 36.7137],
    'طرطوس':      [34.8889, 35.9283],
    'اللاذقية':   [34.7694, 35.7581],
    'درعا':       [32.6155, 36.1086],
    'السويداء':   [32.7249, 36.5683],
    'القنيطرة':   [33.1179, 35.8344],
    'إدلب':       [35.9433, 36.6311],
    'الرقة':      [35.9465, 39.0061],
    'دير الزور':  [35.3405, 40.1449],
    'الحسكة':     [36.498, 40.746],
};

export default function ProtestMap() {
    const mapRef = useRef(null);
    const instanceRef = useRef(null);

    useEffect(() => {
        let alive = true;

        statsService.byGovernorate()
            .then((res) => {
                if (!alive || !mapRef.current) return;

                if (instanceRef.current) {
                    instanceRef.current.remove();
                    instanceRef.current = null;
                }

                const map = L.map(mapRef.current, { zoomControl: true }).setView(SYRIA_CENTER, 6);
                instanceRef.current = map;

                L.tileLayer('https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png', {
                    attribution: '© OpenStreetMap',
                    maxZoom: 18,
                }).addTo(map);

                const counts = {};
                res.data.forEach((item) => {
                    if (item.governorate) counts[item.governorate.name] = Number(item.count);
                });

                Object.entries(counts).forEach(([name, count]) => {
                    const coords = GOVERNORATE_COORDS[name];
                    if (!coords) return;

                    const radius = Math.max(Math.sqrt(count) * 18000, 12000);

                    L.circle(coords, {
                        radius,
                        color: '#00d9ff',
                        fillColor: '#00d9ff',
                        fillOpacity: 0.2,
                        weight: 2,
                    })
                        .bindPopup(`<div dir="rtl" style="font-family:sans-serif"><b>${name}</b><br>الاحتجاجات: ${count}</div>`)
                        .addTo(map);

                    L.marker(coords, {
                        icon: L.divIcon({
                            html: `<div class="map-circle-label">${count}</div>`,
                            className: '',
                            iconSize: [40, 40],
                            iconAnchor: [20, 20],
                        }),
                    })
                        .bindPopup(`<div dir="rtl" style="font-family:sans-serif"><b>${name}</b><br>الاحتجاجات: ${count}</div>`)
                        .addTo(map);
                });
            })
            .catch(console.error);

        return () => {
            alive = false;
            if (instanceRef.current) {
                instanceRef.current.remove();
                instanceRef.current = null;
            }
        };
    }, []);

    return (
        <div className={`${styles.container} text-ar`}>
            <h2 className={styles.title}>خريطة الاحتجاجات بين المحافظات</h2>
            <div ref={mapRef} className={styles.map} />
        </div>
    );
}
